/**
 * 加载JS
 *
 * @author yusangeng@outlook.com
 */
import { __assign } from "tslib";
import { CacheStatus } from '../cache/cache';
import cache from '../cache/js';
import addItem from './define';
function compactAlibabaVCOldVersion(url) {
    // patch: vc4.5.8+依赖g_config中的appkey
    var re = /legao-comp\/(.*)\/[\d.]+\/web.js$/;
    var match = re.exec(url);
    var win = window;
    if (match && match.length > 0) {
        var appKey = match[1];
        win.g_config = win.g_config || {};
        win.g_config.appKey = appKey;
    }
}
function doInstallAJS(item, url, options) {
    item.status = CacheStatus.LOADING;
    compactAlibabaVCOldVersion(url);
    var umd = options.umd, crossOrigin = options.crossOrigin;
    return new Promise(function (resolve, reject) {
        var el = document.createElement('script');
        el.src = url;
        // 保持时序
        el.async = false;
        el.crossOrigin = crossOrigin;
        if (umd) {
            // 用于define函数发生错误时调用, 详见define.ts
            item.reject = reject;
            // 以//开头的地址以及相对地址, 传给el.src后会被补全
            var realURL = el.src;
            // 插入加载队列, 详见define.ts
            addItem(realURL, item);
        }
        var loadCallback = function () {
            el.removeEventListener('load', loadCallback);
            item.status = CacheStatus.LOADED;
            item.el = null;
            resolve(item.exportThing);
        };
        var errorCallback = function (evt) {
            el.removeEventListener('error', errorCallback);
            var error = evt.error || new Error("Load javascript failed. src=".concat(url));
            item.status = CacheStatus.ERROR;
            item.error = error;
            item.el = null;
            reject(error);
        };
        el.addEventListener('load', loadCallback);
        el.addEventListener('error', errorCallback);
        item.el = el;
        document.body.appendChild(el);
    });
}
function installAJS(url, options) {
    var item = cache.getOrCreateItemByURL(url);
    var status = item.status, exportThing = item.exportThing, error = item.error;
    if (status === CacheStatus.LOADED) {
        return Promise.resolve(exportThing);
    }
    if (status === CacheStatus.ERROR) {
        return Promise.reject(error);
    }
    if (status === CacheStatus.LOADING) {
        var el_1 = item.el;
        return new Promise(function (resolve, reject) {
            var loadCallback = function () {
                el_1.removeEventListener('load', loadCallback);
                resolve(item.exportThing);
            };
            var errorCallback = function (evt) {
                el_1.removeEventListener('error', errorCallback);
                reject(evt.error);
            };
            el_1.addEventListener('load', loadCallback);
            el_1.addEventListener('error', errorCallback);
        });
    }
    return doInstallAJS(item, url, options);
}
var defaultInstallOptions = {
    umd: true,
    // 避免window.onerror拿不到脚本的报错, 需要服务器支持
    crossOrigin: 'anonymous'
};
export function installJS(urls, options) {
    var opt = __assign(__assign({}, defaultInstallOptions), options);
    var chain = Promise.resolve();
    var lastIndex = urls.length - 1;
    var umd = opt.umd;
    urls.forEach(function (url, index) {
        // 只有最后一个js使用umd模式加载
        var useUmd = umd && index === lastIndex;
        chain = chain.then(function () { return installAJS(url, __assign(__assign({}, opt), { umd: useUmd })); });
    });
    return chain;
}
//# sourceMappingURL=data:application/json;base64,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